'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const reportUrl = ENV.report
const downloadUrl = ENV.download
// const testUrl = ENV.test
const costumHeader = ENV.costumHeader

const actions = {
  getReportDownloadSummary(context, params = {}) {
    const defaultData = false
    return new Promise(async (resolve) => {
      try {
        const url = `${downloadUrl}/v1/report/downloadsummary?`
        const result = await axios.get(url + params)
        if (result) if (result.data) if (result.data.code == 200) {
          window.open(result.data.data, '_blank')
          return resolve(true)
        }
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getDownloadUserSummary(context, params = '') {
    const defaultData = false
    return new Promise(async (resolve) => {
      try {
        const url = `${reportUrl}/usersummary/download?`
        window.open(url + params, '_blank')
        return resolve(true)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportAttendance(context, params = {}) {
    const defaultData = {total: 0, records: []}
    return new Promise(async (resolve) => {
      try {
        const url = `${reportUrl}/v1/attendancereport/listbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Attendance Report', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportActivity(context, params = {}) {
    const defaultData = {total: 0, records: []}
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/activity/getactivityreportdashboard`
        const result = await axios.get(url, {
          ...costumHeader('Get Activity Report', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportActivityByCompany(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/attendance/listbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Activity Report By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportActivityByHierarchy(context, params = {}) {
    const defaultData = [{attendances: []}]
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/attendance/listbyhiearchy`
        const result = await axios.get(url, {
          ...costumHeader('Get Activity Report By Company', 4),
          params,
        })
        if (result) if (result.data) return resolve(result.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: 'Failed Get data'})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportSummaryPerUser(context, params = {}) {
    const defaultData = {summaries: []}
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/summary/getsummaryperuser`
        const result = await axios.get(url, {
          ...costumHeader('Get Attendance Report per User', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportSummaryPerUserDashboard(context, params = {}) {
    const defaultData = {summaries: []}
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/summary/getsummaryperuserdashboard`
        const result = await axios.get(url, {
          ...costumHeader('Get Attendance Report per User', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportSummaryPerCompany(context, params = {}) {
    const defaultData = { company: [], users: [] }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/summary/getsummarypercompany`
        const result = await axios.get(url, {
          ...costumHeader('Get Attendance Report per Company', 4),
          params,
        })
        if (result) if (result.data) return resolve(result.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: 'Failed to get data'})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportSummaryPerCompanyByGroup(context, params = {}) {
    const defaultData = { company: [], users: [] }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/summary/getsummarypercompanybygroupid`
        const result = await axios.get(url, {
          ...costumHeader('Get Attendance Report per Company', 4),
          params,
        })
        if (result) if (result.data) return resolve(result.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: 'Failed to get data'})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportAttendanceByUser(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/attendance/listbyuseridanddate`
        const result = await axios.get(url, {
          ...costumHeader('Get Attendance Report By User', 4),
          params,
        })
        if (result) if (result.data) return resolve(result.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: 'Failed To Get Data'})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportDownloadSummaryWeekly(context, params = '') {
    const defaultData = false
    return new Promise(async (resolve) => {
      try {
        const url = `${downloadUrl}/v1/report/downloadsummary?`
        window.open(url + params, '_blank')
        return resolve(true)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  downloadLiveTracking(context, params = '') {
    const defaultData = false
    return new Promise(async (resolve) => {
      try {
        const url = `${reportUrl}/liveLocationsReport?`
        window.open(url + params, '_blank')
        return resolve(true)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportDownloadSummaryNew(context, params = '') {
    const defaultData = false
    return new Promise(async (resolve) => {
      try {
        const url = `${reportUrl}/v1/report/downloadsummary?`
        window.open(url + params, '_blank')
        return resolve(true)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getReportNewCleansingShifting(context, params = {}) {
    const defaultData = false
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/summary/newcleansingshift`
        const result = await axios.get(url, {
          ...costumHeader('Get Cleansing Shifting', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  saveReport(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/addresses`
        const result = await axios.post(url, body, costumHeader('Save Report', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editReport(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/addresses/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Report', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteReport(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/addresses/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Report', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }
